import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { resetPassword } from '../../api';
import Button from '../ui/Button';
import './AuthPages.css';

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleReset = async (e) => {
    e.preventDefault();
    if (!email) {
      setError('Введите email');
      return;
    }
    setLoading(true);
    setError('');

    try {
      await resetPassword(email);
      setSent(true);
    } catch (err) {
      setSent(true); // don't reveal if email exists
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="auth-centered">
        <div className="auth-icon">
          <div className="auth-icon-inner">✅</div>
        </div>
        <h2 className="auth-heading">Письмо отправлено</h2>
        <p className="auth-text">
          Проверьте почту <b>{email}</b> и перейдите по ссылке
        </p>
        <div style={{ height: 24 }} />
        <p className="auth-link">
          <span onClick={() => navigate('/login')}>← Войти</span>
        </p>
      </div>
    );
  }

  return (
    <div className="auth-centered">
      <div style={{ width: 76, height: 76, borderRadius: 20, background: 'linear-gradient(135deg, var(--gold), #F2C94C)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 34, boxShadow: '0 8px 24px rgba(242,169,59,0.3)', marginBottom: 16 }}>
        🔑
      </div>
      <h2 className="auth-heading">Сбросить пароль</h2>
      <p className="auth-text">Отправим ссылку на email для создания нового пароля</p>
      <div style={{ height: 20 }} />
      <form onSubmit={handleReset} style={{ width: '100%' }}>
        <input
          className="auth-input"
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        {error && <div className="auth-error">{error}</div>}
        <Button variant="blue" disabled={loading}>
          {loading ? 'Отправляем...' : 'Отправить →'}
        </Button>
      </form>
      <p className="auth-link" style={{ marginTop: 14 }}>
        <span onClick={() => navigate('/login')}>← Назад</span>
      </p>
    </div>
  );
}
